/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * Authentication factor that can be recovered
 * @export
 */
export const RecoverableFactorMethod = {
    Password: 'password'
} as const;
export type RecoverableFactorMethod = typeof RecoverableFactorMethod[keyof typeof RecoverableFactorMethod];


export function instanceOfRecoverableFactorMethod(value: any): boolean {
    for (const key in RecoverableFactorMethod) {
        if (Object.prototype.hasOwnProperty.call(RecoverableFactorMethod, key)) {
            if (RecoverableFactorMethod[key as keyof typeof RecoverableFactorMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RecoverableFactorMethodFromJSON(json: any): RecoverableFactorMethod {
    return RecoverableFactorMethodFromJSONTyped(json, false);
}

export function RecoverableFactorMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecoverableFactorMethod {
    return json as RecoverableFactorMethod;
}

export function RecoverableFactorMethodToJSON(value?: RecoverableFactorMethod | null): any {
    return value as any;
}

export function RecoverableFactorMethodToJSONTyped(value: any, ignoreDiscriminator: boolean): RecoverableFactorMethod {
    return value as RecoverableFactorMethod;
}

